module.exports = __webpack_public_path__ + "img/Jump Casting14.94c8b532.jpg";